import http, { base } from '@/config/http.js'
const namespace = 'files'
const uri = base + '/' + namespace 
const config = {
	headers: {
		'content-type': 'multipart/form-data'
	}
}

/**
 * TODO: replace Tx logic with https://javascript.info/xmlhttprequest
 */ 
export default {
	filesLoad: () => http.get(uri)
		.then(({ data }) => data.data)
		.catch(error => {
			throw Error(`Failed to load, ${namespace} - ${error}`)
		}),

	filesCreate: (file, folder) => {
		const formData = new FormData()
		const type = file.type.split('/')[0] == 'image' ? 'image' : 'pdf'
		formData.append('folder', folder);
		formData.append(type, file)    
		return http.post(uri, formData, config)
			.then(res => res)
			.catch(error => {
				throw Error(`Failed to create, ${namespace} - ${error}`);
			})	
	},

	filesUpdate: (id, file, folder) => {
		const formData = new FormData()
		const type = file.type.split('/')[0] == 'image' ? 'image' : 'pdf'
		formData.append('folder', folder)
		formData.append(type, file)
		return http.post(uri+'/'+id, formData, config)
			.then(res => res)
			.catch(error => {
				throw Error(`Failed to update, ${namespace} - ${error}`);
			})		
	},

	filesDestroy: file => http.delete(`${uri}/${file.id}`)
		.then(({data}) => data)
		.catch(error => {
			throw Error(`Failed to delete, ${namespace} - ${error}`);
		})
}
